import { ESerpTypes } from "app/common/serp/SerpFilterMaps";

/** Ads — excluded by default (DMI-18150). */
export const DEFAULT_EXCLUDED_FEATURE = ESerpTypes.paid;

export const DEFAULT_EXCLUDED_FEATURES: ESerpTypes[] = [DEFAULT_EXCLUDED_FEATURE];

export const SUPPORTED_EXCLUDED_FEATURES: ESerpTypes[] = Object.values(ESerpTypes);
